"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectTabContent = void 0;
const reselect_1 = require("reselect");
const selectTabContents_1 = require("./selectTabContents");
exports.selectTabContent = (0, reselect_1.createSelector)(selectTabContents_1.selectTabContents, content => (type) => content && content[type]);
